import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createBlock as _createBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "mt-4 space-y-3",
  "aria-label": "Propositions de remplacement"
}
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-green-800",
  role: "status"
}
const _hoisted_3 = {
  key: 1,
  class: "text-sm text-red-700",
  role: "alert"
}
const _hoisted_4 = { class: "flex flex-wrap items-center justify-between gap-2" }
const _hoisted_5 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_6 = { class: "text-xs text-gray-500" }
const _hoisted_7 = {
  key: 0,
  class: "flex flex-wrap gap-3"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["disabled", "onClick"]
const _hoisted_10 = ["title"]
const _hoisted_11 = {
  key: 1,
  class: "mt-2 text-amber-800",
  role: "status"
}
const _hoisted_12 = ["open", "onToggle"]
const _hoisted_13 = ["aria-current"]
const _hoisted_14 = ["aria-current"]
const _hoisted_15 = {
  key: 0,
  class: "mb-4 rounded-lg border p-3"
}
const _hoisted_16 = { class: "px-1 text-sm font-semibold" }
const _hoisted_17 = { class: "grid gap-2 sm:grid-cols-2" }
const _hoisted_18 = ["checked", "disabled", "onChange"]
const _hoisted_19 = { class: "min-w-0" }
const _hoisted_20 = { class: "break-words" }
const _hoisted_21 = { class: "block text-xs text-gray-600" }
const _hoisted_22 = {
  key: 1,
  class: "mb-3 block text-sm"
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = ["value"]
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 3,
  class: "mb-4 text-xs text-gray-600"
}
const _hoisted_27 = ["id"]
const _hoisted_28 = { class: "flex flex-wrap items-start justify-between gap-3 rounded-lg bg-red-50 p-3" }
const _hoisted_29 = { class: "min-w-0 text-sm" }
const _hoisted_30 = { class: "font-semibold break-words" }
const _hoisted_31 = { class: "mt-1 text-gray-600" }
const _hoisted_32 = {
  key: 0,
  class: "text-sm"
}
const _hoisted_33 = { class: "font-semibold" }
const _hoisted_34 = {
  key: 1,
  class: "text-xs text-gray-600"
}
const _hoisted_35 = ["disabled", "onClick"]
const _hoisted_36 = { class: "rounded bg-indigo-50 p-2 text-sm text-indigo-800" }
const _hoisted_37 = {
  key: 5,
  class: "space-y-4",
  "aria-label": "Quantités et montants des remplacements"
}
const _hoisted_38 = ["id", "aria-label"]
const _hoisted_39 = { class: "overflow-hidden rounded-lg border border-gray-200" }
const _hoisted_40 = { class: "grid sm:grid-cols-2" }
const _hoisted_41 = { class: "min-w-0 space-y-3 bg-red-50 p-4 text-sm" }
const _hoisted_42 = { class: "flex items-start gap-3" }
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "min-w-0 space-y-2 break-words" }
const _hoisted_45 = { class: "font-semibold" }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { class: "min-w-0 space-y-4 bg-green-50 p-4 text-sm" }
const _hoisted_49 = { class: "text-xs font-semibold uppercase text-gray-600" }
const _hoisted_50 = { class: "flex items-start gap-3" }
const _hoisted_51 = ["src"]
const _hoisted_52 = { class: "min-w-0 flex-1 space-y-2 break-words" }
const _hoisted_53 = { class: "font-semibold" }
const _hoisted_54 = ["disabled", "onClick"]
const _hoisted_55 = {
  key: 0,
  class: "block"
}
const _hoisted_56 = ["onUpdate:modelValue", "disabled", "onInput"]
const _hoisted_57 = {
  key: 1,
  class: "text-xs text-gray-600"
}
const _hoisted_58 = { class: "flex flex-wrap gap-3" }
const _hoisted_59 = ["value", "disabled", "max", "onInput"]
const _hoisted_60 = {
  key: 0,
  class: "text-amber-800"
}
const _hoisted_61 = {
  key: 1,
  class: "text-blue-700"
}
const _hoisted_62 = {
  key: 3,
  class: "space-y-1 text-amber-800",
  role: "status"
}
const _hoisted_63 = {
  key: 4,
  class: "text-indigo-700",
  role: "status"
}
const _hoisted_64 = ["disabled", "onClick"]
const _hoisted_65 = {
  key: 6,
  class: "mt-3 text-sm text-gray-600"
}
const _hoisted_66 = { class: "w-full space-y-3 border-t border-gray-200 pt-3" }
const _hoisted_67 = {
  key: 0,
  class: "text-sm text-indigo-700",
  role: "status"
}
const _hoisted_68 = {
  key: 1,
  class: "text-sm text-amber-800",
  role: "status"
}
const _hoisted_69 = ["disabled", "onClick"]
const _hoisted_70 = {
  key: 2,
  class: "text-sm text-gray-600",
  role: "status"
}
const _hoisted_71 = {
  key: 3,
  class: "text-sm text-red-700",
  role: "alert"
}
const _hoisted_72 = {
  key: 4,
  class: "rounded border border-amber-300 bg-amber-50 p-2 text-sm font-semibold text-amber-900",
  role: "status"
}
const _hoisted_73 = {
  key: 5,
  class: "flex cursor-pointer items-start gap-3 rounded-lg bg-indigo-50 p-3 text-sm text-indigo-950"
}
const _hoisted_74 = ["disabled"]
const _hoisted_75 = { class: "flex flex-wrap justify-end gap-2" }
const _hoisted_76 = ["disabled"]
const _hoisted_77 = ["disabled"]
const _hoisted_78 = ["disabled"]
const _hoisted_79 = ["disabled"]

import { computed, nextTick, onUnmounted, ref, watch } from 'vue';
import ModalComp from '@/components/ui/ModalComp.vue';
import { useAuthStore } from '@/stores/auth';
import ReplacementComparison from './ReplacementComparison.vue';
import EditReplacementCandidateModal from './EditReplacementCandidateModal.vue';
import ReplacementProductPicker from './ReplacementProductPicker.vue';
import ReplacementReferenceSearch from './ReplacementReferenceSearch.vue';
import type { OrderProduct } from '@/types';
import { cancelReplacement, fetchOrderReplacements, fetchReplacementProducts, previewReplacement, proposeReplacement,
  replacementLineProducts, replacementMoney, replacementStatus } from '@/api/remplacements';
import type { ReplacementAppliedProduct, ReplacementInput, ReplacementLine, ReplacementProduct, ReplacementProposal, ReplacementSelection } from '@/api/remplacements';


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderReplacements',
  props: {
    orderId: {},
    products: {},
    canPropose: { type: Boolean }
  },
  emits: ["changed", "settled", "replacementConfirmation"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;
const auth = useAuthStore();
const canManageLinks = computed(() => auth.isImpersonating);
const canEditRecommendations = computed(() => props.canPropose && canManageLinks.value);
const replacementStatusClasses: Record<ReplacementProposal['statut'], string> = {
  pending: 'bg-indigo-100 text-indigo-800 ring-indigo-200',
  accepted: 'bg-emerald-100 text-emerald-800 ring-emerald-200',
  rejected: 'bg-red-100 text-red-800 ring-red-200',
  expired: 'bg-amber-100 text-amber-900 ring-amber-200',
  cancelled: 'bg-gray-100 text-gray-700 ring-gray-200',
  confirmer: 'bg-emerald-100 text-emerald-800 ring-emerald-200',
};
const emit = __emit;
const proposals = ref<ReplacementProposal[]>([]);
const now = ref(Date.now());
const products = ref<ReplacementProduct[]>([]);
const candidatesByLine = ref<Record<number, number[]>>({});
const appliedSearch = ref('');
let searchVersion = 0;
let searchTimer: ReturnType<typeof window.setTimeout> | null = null;
let quoteTimer: ReturnType<typeof window.setTimeout> | null = null;
let quoteVersion = 0;
const searchTargetLineId = ref(0);
const selections = ref<ReplacementSelection[]>([]);
const selectedLineIds = ref<number[]>([]);
const visible = ref(false);
const step = ref<1 | 2>(1);
const stepsHeader = ref<HTMLOListElement | null>(null);
const search = ref('');
const searching = ref(false);
const busy = ref(false);
const quoting = ref(false);
const quoteError = ref('');
const confirmed = ref(false);
const preview = ref<ReplacementLine[] | null>(null);
const quoteHash = ref('');
const fixedDiscount = ref(0);
const modalError = ref('');
const loadError = ref('');
const loadInfo = ref('');
const expandedProposalId = ref<string | null>(null);
const candidateEditor = ref<InstanceType<typeof EditReplacementCandidateModal> | null>(null);
const sellerCharge = computed(() => (preview.value || []).reduce((sum, line) => sum + (line.charge_vendeur_max_ttc ?? line.charge_vendeur_ttc), 0));
const searchTarget = computed(() => selections.value.find(s => s.id_ligne_origine === searchTargetLineId.value));
const referenceSuggestions = computed(() => searchTarget.value ? availableProducts(searchTargetLineId.value) : []);
const original = (id: number) => props.products.find(p => p.id === id);
const product = (selection: ReplacementSelection) => products.value.find(p => p.id_produit === selection.id_produit_remplacement);
const quotedLines = computed(() => new Map((preview.value || []).map(line => [line.id_ligne_origine, line])));
const quotedLine = (id: number) => quotedLines.value.get(id);
const quotedProducts = computed(() => new Map((preview.value || []).flatMap(line =>
  replacementLineProducts(line).map(candidate => [`${line.id_ligne_origine}:${candidate.id_produit}`, candidate] as const))));
const quotedProduct = (selection: ReplacementSelection) => quotedProducts.value.get(`${selection.id_ligne_origine}:${selection.id_produit_remplacement}`);
const readySelections = computed(() => selections.value.filter(selectionReady));
const incompleteOrigins = computed(() => selectedLineIds.value.filter(id => originEnabled(id) && (!selectedFor(id).length || selectedFor(id).some(s => !selectionReady(s)))));
const missingCandidates = computed(() => selectedLineIds.value.filter(id => originEnabled(id) && !selectedFor(id).length));
const candidatesChosen = computed(() => selections.value.length > 0 && missingCandidates.value.length === 0 && selections.value.every(s => Boolean(product(s))));
const stepIncompleteOrigins = computed(() => step.value === 1 ? missingCandidates.value : incompleteOrigins.value);
const complete = computed(() => selections.value.length > 0 && readySelections.value.length === selections.value.length);
const quoteReady = computed(() => complete.value && Boolean(quoteHash.value) && preview.value?.length === new Set(selections.value.map(s => s.id_ligne_origine)).size);
const quoteKey = computed(() => JSON.stringify({ order: props.orderId, lines: selections.value.map(s => ({ ...s, price: product(s)?.prix_unitaire_ht, pack: product(s)?.pack, minimum: product(s)?.qte_mini, mode: product(s)?.vendu_par })) }));
const date = (value: string | number) => new Date(value).toLocaleString('fr-FR');
const input = (): ReplacementInput => ({ id_commande: props.orderId, lignes: selections.value, stock_confirme: confirmed.value, quote_hash: quoteHash.value });
const errorMessage = (error: unknown) => error instanceof Error ? error.message : 'Une erreur est survenue';
function responseDeadline(proposal: ReplacementProposal) {
  return new Date(proposal.date_expiration).getTime();
}
function remainingSeconds(proposal: ReplacementProposal) {
  return Math.max(0, Math.ceil((responseDeadline(proposal) - now.value) / 1000));
}
function countdown(proposal: ReplacementProposal) {
  const seconds = remainingSeconds(proposal);
  return [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60]
    .map(value => String(value).padStart(2, '0')).join(':');
}
function displayStatus(proposal: ReplacementProposal) {
  if (proposal.statut !== 'pending' || remainingSeconds(proposal) > 0) return proposal.statut;
  return proposal.lignes.some(line => line.statut === 'accepted' || line.accepted === 1) ? 'accepted' : 'expired';
}
function hasExpiredLines(proposal: ReplacementProposal) {
  return proposal.lignes.some(line => line.statut === 'expired') ||
    (proposal.statut === 'pending' && remainingSeconds(proposal) === 0);
}
function quantityErrors(selection: ReplacementSelection): string[] {
  const p = product(selection);
  if (!p) return ['Choisissez un produit de remplacement disponible.'];
  if (!Number.isSafeInteger(selection.quantite_pack) || selection.quantite_pack < 1 || selection.quantite_pack > 10000) return ['Quantité de paquets : saisissez un nombre entier entre 1 et 10 000.'];
  const q = selection.quantites;
  if (q.length !== 12) return ['Quantités incomplètes : sélectionnez à nouveau ce produit.'];
  const errors = q.flatMap((n, i) => {
    const label = p.tailles[i] || `Taille ${i + 1}`;
    if (!Number.isSafeInteger(n) || n < 0 || n > 10000) return [`${label} : saisissez un nombre entier entre 0 et 10 000.`];
    if (p.vendu_par === 'tailles') return n && !p.tailles[i] ? [`${label} : taille non disponible pour ce produit.`] : [];
    const maximum = p.pack[i] * selection.quantite_pack;
    return n <= maximum ? [] : [`${label} : ${n} pièce(s) saisie(s), maximum ${maximum} pour ${selection.quantite_pack} paquet(s).`];
  });
  if (errors.length) return errors;
  const count = q.reduce((sum, n) => sum + n, 0);
  if (count === 0) return ['Sélectionnez au moins une pièce pour ce produit.'];
  if (count > 10000) return ['Quantité totale : 10 000 pièces maximum par produit.'];
  if (p.vendu_par === 'tailles' && !(count >= p.qte_mini)) return [`Quantité totale : minimum ${p.qte_mini} pièce(s) pour ce produit (${count} saisie(s)).`];
  return [];
}
function selectionReady(selection: ReplacementSelection) { return quantityErrors(selection).length === 0; }
function stopQuote() {
  if (quoteTimer != null) window.clearTimeout(quoteTimer);
  quoteTimer = null;
  quoteVersion++;
  quoting.value = false;
}
function invalidate() {
  stopQuote();
  preview.value = null; quoteHash.value = ''; confirmed.value = false; fixedDiscount.value = 0; quoteError.value = '';
  if (visible.value && step.value === 2 && readySelections.value.length) {
    quoting.value = true;
    quoteTimer = window.setTimeout(() => { void refreshQuote(); }, 300);
  }
}
function availableProducts(lineId: number) {
  const ids = new Set(candidatesByLine.value[lineId] || []);
  return products.value.filter(p => ids.has(p.id_produit) && p.id_produit !== original(lineId)?.productId);
}
function selectedFor(lineId: number) { return selections.value.filter(s => s.id_ligne_origine === lineId && s.id_produit_remplacement > 0); }
async function focusStepHeader() {
  await nextTick();
  stepsHeader.value?.scrollIntoView({ block: 'start' });
  stepsHeader.value?.focus({ preventScroll: true });
}
function nextStep() {
  if (busy.value || searching.value || !candidatesChosen.value) return;
  step.value = 2;
  modalError.value = '';
  invalidate();
  void focusStepHeader();
}
function previousStep() {
  if (busy.value) return;
  step.value = 1;
  modalError.value = '';
  invalidate();
  void focusStepHeader();
}
async function focusOrigin(lineId: number) {
  if (step.value === 2 && !selectedFor(lineId).length) previousStep();
  searchTargetLineId.value = lineId;
  await nextTick();
  const section = document.getElementById(`replacement-origin-${lineId}`);
  section?.scrollIntoView({ block: 'start', behavior: 'smooth' });
  section?.focus({ preventScroll: true });
}
function originEnabled(lineId: number) { return selections.value.some(s => s.id_ligne_origine === lineId); }
function toggleOrigin(lineId: number) {
  if (originEnabled(lineId)) selections.value = selections.value.filter(s => s.id_ligne_origine !== lineId);
  else selections.value.push(emptySelection(lineId));
  modalError.value = '';
  invalidate();
}
function emptySelection(lineId: number): ReplacementSelection { return { id_ligne_origine: lineId, id_produit_remplacement: 0, quantites: Array(12).fill(0), quantite_pack: 1 }; }
function removeProduct(selection: ReplacementSelection) {
  modalError.value = '';
  selections.value = selections.value.filter(s => s !== selection);
  if (!selectedFor(selection.id_ligne_origine).length) selections.value.push(emptySelection(selection.id_ligne_origine));
  invalidate();
}
function toggleProduct(lineId: number, productId: number, allowRemoval = true) {
  const current = selectedFor(lineId).find(s => s.id_produit_remplacement === productId);
  if (current) { if (allowRemoval) removeProduct(current); return; }
  if (selectedFor(lineId).length >= 10) { modalError.value = '10 articles maximum par ligne.'; return; }
  let selection = selections.value.find(s => s.id_ligne_origine === lineId && !s.id_produit_remplacement);
  if (!selection) {
    selections.value.push(emptySelection(lineId));
    selection = selections.value[selections.value.length - 1];
  }
  modalError.value = '';
  choose(selection, productId);
}
function originalAmount(id: number) {
  const p = original(id);
  const ht = p?.priceLineHT ?? p?.price;
  if (typeof ht !== 'number' || !Number.isFinite(ht)) return null;
  return `${replacementMoney(ht)} HT${p?.priceLineTTC != null ? ` · ${replacementMoney(p.priceLineTTC)} TTC` : ''}`;
}
function originalQuantity(id: number) {
  const p = original(id);
  const quantity = p?.quantites ? Object.values(p.quantites).reduce((sum, q) => sum + (Number(q) || 0), 0) : 0;
  return quantity || p?.quantite_total || p?.details || 0;
}
function originalSizes(id: number) {
  const p = original(id);
  return Object.entries(p?.quantites || {}).filter(([, quantity]) => Number(quantity) > 0).map(([key, quantity]) => {
    const label = p?.declinaisons?.[`d${key.slice(1)}_FR` as keyof NonNullable<OrderProduct['declinaisons']>];
    return `${label || 'Assortiment'} × ${quantity}`;
  }).join(' · ');
}
function sizeInputs(selection: ReplacementSelection) {
  const p = product(selection);
  return p ? p.tailles.map((label, index) => ({ label: label || 'Assortiment', index }))
    .filter(size => p.vendu_par === 'tailles' ? Boolean(p.tailles[size.index]) : p.pack[size.index] > 0) : [];
}
function updateSizeQuantity(selection: ReplacementSelection, index: number, event: Event) {
  const input = event.target as HTMLInputElement;
  if (input.value === '' && !input.validity.badInput) input.value = '0';
  selection.quantites[index] = input.value === '' ? NaN : Number(input.value);
  invalidate();
}
function updatePacks(selection: ReplacementSelection) {
  const p = product(selection);
  if (p) selection.quantites = p.pack.map(q => q * selection.quantite_pack);
  invalidate();
}
function choose(selection: ReplacementSelection, productId: number) {
  if (selection.id_produit_remplacement === productId) return;
  selection.id_produit_remplacement = productId;
  selection.quantite_pack = 1;
  selection.quantites = Array(12).fill(0);
  const p = product(selection);
  if (p?.vendu_par !== 'tailles') updatePacks(selection);
  invalidate();
}
function chooseReference(productId: number) {
  if (!searchTarget.value) return;
  toggleProduct(searchTargetLineId.value, productId, false);
  search.value = products.value.find(p => p.id_produit === productId)?.reference || search.value;
}
function clearSearchTimer() {
  if (searchTimer != null) window.clearTimeout(searchTimer);
  searchTimer = null;
}
function protectedLineIds(rows: ReplacementProposal[]) {
  return rows.flatMap(proposal => proposal.lignes.filter(line => {
    const status = line.statut || (line.accepted ? 'accepted' : line.rejected ? 'rejected' : proposal.statut);
    return ['accepted', 'expired', 'pending'].includes(status);
  }).map(line => line.id_ligne_origine));
}
function onDetailsToggle(id: string, event: Event) {
  if (!(event.target as HTMLDetailsElement).open && expandedProposalId.value === id) expandedProposalId.value = null;
}
function openCandidateEditor(proposal: ReplacementProposal, line: ReplacementLine, product: ReplacementAppliedProduct, action: 'quantity' | 'remove' | 'product') {
  if (!canEditRecommendations.value) return;
  void candidateEditor.value?.open(proposal, line, product, action);
}
async function onCandidateSaved() {
  loadInfo.value = 'Recommandation mise à jour.';
  await load(); emit('changed');
}
async function load() {
  const id = props.orderId;
  try {
    const result = await fetchOrderReplacements(id, canManageLinks.value);
    if (id !== props.orderId) return;
    const changed = proposals.value.length > 0 && (proposals.value.length !== result.length || proposals.value.some(old => {
      const current = result.find(proposal => proposal.id_jet === old.id_jet);
      return !current || current.statut !== old.statut || current.confirmation_remplacements !== old.confirmation_remplacements ||
        JSON.stringify(current.lignes) !== JSON.stringify(old.lignes);
    }));
    proposals.value = result;
    loadError.value = '';
    emit('settled', protectedLineIds(result));
    emit('replacementConfirmation', result.some(proposal => proposal.confirmation_remplacements === true));
    if (changed) emit('changed');
  } catch (error) { loadError.value = errorMessage(error); emit('replacementConfirmation', false); }
}
async function searchProducts() {
  clearSearchTimer();
  const version = ++searchVersion;
  const orderId = props.orderId;
  const term = search.value.trim();
  searching.value = true;
  modalError.value = '';
  try {
    const requests = new Map<string, ReturnType<typeof fetchReplacementProducts>>();
    const results = await Promise.all(selectedLineIds.value.map(async lineId => {
      const category = original(lineId)?.id_categorie;
      const key = term ? 'reference' : category ? `category:${category}` : `line:${lineId}`;
      let request = requests.get(key);
      if (!request) {
        request = fetchReplacementProducts(orderId, term, lineId, canManageLinks.value);
        requests.set(key, request);
      }
      return { lineId, rows: await request };
    }));
    if (version !== searchVersion || orderId !== props.orderId || !visible.value) return;
    const selectedIds = new Set(selections.value.map(s => s.id_produit_remplacement));
    const merged = new Map(products.value.filter(p => selectedIds.has(p.id_produit)).map(p => [p.id_produit, p]));
    const byLine: Record<number, number[]> = {};
    for (const result of results) {
      byLine[result.lineId] = result.rows.map(p => p.id_produit);
      result.rows.forEach(p => merged.set(p.id_produit, p));
    }
    products.value = [...merged.values()];
    candidatesByLine.value = byLine;
    appliedSearch.value = term;
  } catch (error) { if (version === searchVersion) modalError.value = errorMessage(error); }
  finally { if (version === searchVersion) searching.value = false; }
}
async function open() {
  if (!props.canPropose) return;
  loadInfo.value = '';
  modalError.value = '';
  await load();
  if (!props.canPropose) return;
  const alreadyReplaced = new Set(protectedLineIds(proposals.value));
  const eligible = props.products.map(p => p.id).filter(id => !alreadyReplaced.has(id));
  if (!eligible.length) { loadError.value = 'Tous les articles sont déjà proposés, remplacés ou hors délai. Ajoutez une nouvelle ligne en rupture pour proposer un autre remplacement.'; return; }
  selectedLineIds.value = [...new Set(eligible)];
  selections.value = selectedLineIds.value.map(emptySelection);
  searchTargetLineId.value = eligible[0];
  candidatesByLine.value = {};
  search.value = '';
  appliedSearch.value = '';
  preview.value = null;
  confirmed.value = false;
  step.value = 1;
  visible.value = true;
  await searchProducts();
}
async function refreshQuote() {
  stopQuote();
  if (!props.canPropose || !visible.value || step.value !== 2 || !readySelections.value.length) return;
  const version = quoteVersion;
  const orderId = props.orderId;
  const lines = readySelections.value.map(s => ({ ...s, quantites: [...s.quantites] }));
  quoting.value = true;
  quoteError.value = '';
  try {
    const result = await previewReplacement({ id_commande: orderId, lignes: lines, stock_confirme: false }, canManageLinks.value);
    if (version !== quoteVersion || orderId !== props.orderId || !visible.value) return;
    preview.value = result.lignes;
    quoteHash.value = result.quote_hash;
    fixedDiscount.value = result.remise_fixe_commande_ht || 0;
  }
  catch (error) { if (version === quoteVersion && visible.value) quoteError.value = errorMessage(error); }
  finally { if (version === quoteVersion) quoting.value = false; }
}
async function submit() {
  if (!props.canPropose || step.value !== 2 || busy.value || quoting.value || !confirmed.value || !quoteReady.value) return;
  const orderId = props.orderId;
  busy.value = true;
  modalError.value = '';
  try {
    const result = await proposeReplacement(input());
    if (orderId !== props.orderId) return;
    loadInfo.value = result.lien_conserve ? 'Articles ajoutés à la proposition.' : '';
    visible.value = false;
    await load();
    emit('changed');
  } catch (error) { modalError.value = errorMessage(error); invalidate(); }
  finally { busy.value = false; }
}
async function cancel(id: string) {
  if (busy.value) return;
  busy.value = true;
  try { await cancelReplacement(id, props.orderId); loadInfo.value = ''; await load(); emit('changed'); }
  catch (error) { loadError.value = errorMessage(error); }
  finally { busy.value = false; }
}
watch(search, () => {
  clearSearchTimer();
  searchVersion++;
  candidatesByLine.value = {};
  if (!visible.value) return;
  searching.value = true;
  searchTimer = window.setTimeout(() => { void searchProducts(); }, search.value.trim() ? 300 : 0);
}, { flush: 'sync' });
watch(visible, value => {
  if (!value) { clearSearchTimer(); searchVersion++; searching.value = false; stopQuote(); }
});
watch(() => props.canPropose, allowed => { if (!allowed) visible.value = false; });
watch(() => props.orderId, () => { searchVersion++; searching.value = false; candidatesByLine.value = {}; visible.value = false; void load(); }, { immediate: true });
watch(quoteKey, invalidate, { flush: 'sync' });
watch(() => proposals.value.filter(proposal => proposal.statut === 'pending' && remainingSeconds(proposal) === 0).map(proposal => proposal.id_jet).join(','), ids => {
  if (ids && !busy.value) void load();
});
const clock = window.setInterval(() => { now.value = Date.now(); }, 1000);
const timer = window.setInterval(() => { if (!visible.value && !busy.value) void load(); }, 30000);
onUnmounted(() => { window.clearInterval(clock); window.clearInterval(timer); clearSearchTimer(); searchVersion++; stopQuote(); });
__expose({ open });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (loadInfo.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(loadInfo.value), 1))
      : _createCommentVNode("", true),
    (loadError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(loadError.value) + " ", 1),
          _createElementVNode("button", {
            type: "button",
            class: "underline",
            onClick: load
          }, "Réessayer")
        ]))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proposals.value, (proposal) => {
      return (_openBlock(), _createElementBlock("article", {
        key: proposal.id_jet,
        class: "rounded-lg border border-indigo-200 bg-indigo-50 p-3 text-sm"
      }, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              role: "status",
              class: _normalizeClass(["inline-flex items-center rounded-full px-3 py-1.5 text-sm font-semibold ring-1 ring-inset", replacementStatusClasses[displayStatus(proposal)]])
            }, _toDisplayString(_unref(replacementStatus)[displayStatus(proposal)]), 3),
            _createElementVNode("span", _hoisted_6, "v" + _toDisplayString(proposal.version), 1)
          ]),
          (proposal.statut === 'pending' && remainingSeconds(proposal) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (canEditRecommendations.value && remainingSeconds(proposal) > 0)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "text-indigo-700 underline",
                      onClick: ($event: any) => (expandedProposalId.value = expandedProposalId.value === proposal.id_jet ? null : proposal.id_jet)
                    }, "Modifier", 8, _hoisted_8))
                  : _createCommentVNode("", true),
                _createElementVNode("button", {
                  type: "button",
                  disabled: busy.value,
                  class: "text-red-700 underline disabled:opacity-50",
                  onClick: ($event: any) => (cancel(proposal.id_jet))
                }, "Annuler", 8, _hoisted_9)
              ]))
            : _createCommentVNode("", true)
        ]),
        (proposal.statut === 'pending' && remainingSeconds(proposal) > 0)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("p", {
                class: "mt-3 inline-flex items-center rounded-full bg-amber-100 px-3 py-1.5 font-semibold tabular-nums text-amber-900 ring-1 ring-inset ring-amber-200",
                title: `Réponse avant le ${date(responseDeadline(proposal))}`,
                role: "timer",
                "aria-label": "Temps restant pour répondre"
              }, "Temps restant : " + _toDisplayString(countdown(proposal)), 9, _hoisted_10),
              _cache[5] || (_cache[5] = _createElementVNode("p", { class: "mt-2 text-gray-600" }, "Sans réponse, les articles restent en rupture.", -1))
            ], 64))
          : _createCommentVNode("", true),
        (hasExpiredLines(proposal))
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, "Les articles sans réponse restent en rupture."))
          : _createCommentVNode("", true),
        _createElementVNode("details", {
          open: expandedProposalId.value === proposal.id_jet,
          class: "mt-2",
          onToggle: ($event: any) => (onDetailsToggle(proposal.id_jet, $event))
        }, [
          _cache[6] || (_cache[6] = _createElementVNode("summary", { class: "cursor-pointer" }, "Articles et montants", -1)),
          _createVNode(ReplacementComparison, {
            lines: proposal.lignes,
            provisional: proposal.montants_provisoires,
            editable: canEditRecommendations.value && proposal.statut === 'pending' && remainingSeconds(proposal) > 0,
            class: "mt-3",
            onEdit: (line, product, action) => openCandidateEditor(proposal, line, product, action)
          }, null, 8, ["lines", "provisional", "editable", "onEdit"])
        ], 40, _hoisted_12)
      ]))
    }), 128)),
    (canEditRecommendations.value)
      ? (_openBlock(), _createBlock(EditReplacementCandidateModal, {
          key: 2,
          ref_key: "candidateEditor",
          ref: candidateEditor,
          onSaved: onCandidateSaved
        }, null, 512))
      : _createCommentVNode("", true),
    _createVNode(ModalComp, {
      isVisible: visible.value,
      "onUpdate:isVisible": _cache[4] || (_cache[4] = ($event: any) => ((visible).value = $event)),
      title: "Proposer des remplacements",
      size: "xl"
    }, {
      body: _withCtx(() => [
        _createElementVNode("ol", {
          ref_key: "stepsHeader",
          ref: stepsHeader,
          tabindex: "-1",
          class: "mb-4 flex flex-wrap gap-3 text-sm",
          "aria-label": "Étapes de la proposition"
        }, [
          _createElementVNode("li", {
            "aria-current": step.value === 1 ? 'step' : undefined,
            class: _normalizeClass(step.value === 1 ? 'font-semibold text-indigo-700' : 'text-gray-500')
          }, "1. Choisir les produits", 10, _hoisted_13),
          _createElementVNode("li", {
            "aria-current": step.value === 2 ? 'step' : undefined,
            class: _normalizeClass(step.value === 2 ? 'font-semibold text-indigo-700' : 'text-gray-500')
          }, "2. Quantités et confirmation", 10, _hoisted_14)
        ], 512),
        (step.value === 1)
          ? (_openBlock(), _createElementBlock("fieldset", _hoisted_15, [
              _createElementVNode("legend", _hoisted_16, "Articles en rupture (" + _toDisplayString(selectedLineIds.value.length) + ")", 1),
              _createElementVNode("div", _hoisted_17, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLineIds.value, (id) => {
                  return (_openBlock(), _createElementBlock("label", {
                    key: id,
                    class: "flex items-start gap-2 rounded bg-red-50 p-2 text-sm"
                  }, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: originEnabled(id),
                      disabled: busy.value,
                      class: "mt-1 shrink-0",
                      onChange: ($event: any) => (toggleOrigin(id))
                    }, null, 40, _hoisted_18),
                    _createElementVNode("span", _hoisted_19, [
                      _createElementVNode("strong", _hoisted_20, _toDisplayString(original(id)?.reference || id), 1),
                      _createElementVNode("span", _hoisted_21, _toDisplayString(selectedFor(id).length) + " candidat(s) proposé(s)", 1)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (step.value === 1 && selectedLineIds.value.length > 1)
          ? (_openBlock(), _createElementBlock("label", _hoisted_22, [
              _cache[7] || (_cache[7] = _createTextVNode("Article à remplacer ")),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTargetLineId).value = $event)),
                disabled: busy.value,
                class: "mt-1 block w-full rounded border p-2"
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLineIds.value, (id) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: id,
                    value: id
                  }, _toDisplayString(original(id)?.reference) + " — ligne #" + _toDisplayString(id), 9, _hoisted_24))
                }), 128))
              ], 8, _hoisted_23), [
                [
                  _vModelSelect,
                  searchTargetLineId.value,
                  void 0,
                  { number: true }
                ]
              ])
            ]))
          : _createCommentVNode("", true),
        (step.value === 1)
          ? (_openBlock(), _createElementBlock("form", {
              key: 2,
              class: "grid grid-cols-[minmax(0,1fr)_auto] items-start gap-2 mb-4",
              onSubmit: _withModifiers(searchProducts, ["prevent"])
            }, [
              _createVNode(ReplacementReferenceSearch, {
                modelValue: search.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((search).value = $event)),
                products: referenceSuggestions.value,
                selection: searchTarget.value,
                loading: searching.value,
                disabled: busy.value,
                onChoose: chooseReference,
                onSearch: searchProducts
              }, null, 8, ["modelValue", "products", "selection", "loading", "disabled"]),
              _createElementVNode("button", {
                type: "submit",
                disabled: searching.value || busy.value,
                class: "col-start-2 row-start-1 border rounded px-3 py-2"
              }, _toDisplayString(searching.value ? 'Recherche…' : 'Rechercher'), 9, _hoisted_25)
            ], 32))
          : _createCommentVNode("", true),
        (step.value === 1 && appliedSearch.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_26, "Recherche : « " + _toDisplayString(appliedSearch.value) + " »", 1))
          : _createCommentVNode("", true),
        (step.value === 1)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(selectedLineIds.value, (originId) => {
              return (_openBlock(), _createElementBlock("div", {
                id: `replacement-origin-${originId}`,
                key: originId,
                tabindex: "-1",
                class: "border rounded-lg p-3 mb-3 space-y-3"
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("p", _hoisted_30, "En rupture : " + _toDisplayString(original(originId)?.reference || originId), 1),
                    _createElementVNode("p", _hoisted_31, [
                      _createTextVNode(_toDisplayString(original(originId)?.categorie || 'Catégorie non renseignée'), 1),
                      (originalQuantity(originId))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(" · " + _toDisplayString(originalQuantity(originId)) + " pièce(s)", 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  (originalAmount(originId))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        _createElementVNode("p", _hoisted_33, "Origine : " + _toDisplayString(originalAmount(originId)), 1),
                        _cache[8] || (_cache[8] = _createElementVNode("p", { class: "text-xs text-gray-600" }, "Avant remises", -1))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_34, "Montant d’origine non renseigné."))
                ]),
                (originEnabled(originId))
                  ? (_openBlock(), _createBlock(ReplacementProductPicker, {
                      key: 0,
                      products: availableProducts(originId),
                      "selected-ids": selectedFor(originId).map(s => s.id_produit_remplacement),
                      selections: selectedFor(originId),
                      loading: searching.value,
                      disabled: busy.value,
                      onChoose: ($event: any) => (toggleProduct(originId, $event))
                    }, null, 8, ["products", "selected-ids", "selections", "loading", "disabled", "onChoose"]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFor(originId), (selection) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: selection.id_produit_remplacement,
                    class: "space-y-3 rounded-lg border p-3"
                  }, [
                    _createElementVNode("button", {
                      type: "button",
                      disabled: busy.value,
                      class: "float-right text-sm text-red-700 underline",
                      onClick: ($event: any) => (removeProduct(selection))
                    }, "Retirer", 8, _hoisted_35),
                    _createElementVNode("p", _hoisted_36, [
                      _createElementVNode("strong", null, _toDisplayString(product(selection)?.reference), 1),
                      _createTextVNode(" · " + _toDisplayString(product(selection)?.couleur), 1)
                    ])
                  ]))
                }), 128))
              ], 8, _hoisted_27))
            }), 128))
          : (_openBlock(), _createElementBlock("div", _hoisted_37, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedLineIds.value.filter(originEnabled), (originId) => {
                return (_openBlock(), _createElementBlock("section", {
                  id: `replacement-origin-${originId}`,
                  key: originId,
                  tabindex: "-1",
                  "aria-label": `Remplacements pour ${original(originId)?.reference || originId}`
                }, [
                  _createElementVNode("article", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-xs font-semibold uppercase text-gray-600" }, "En rupture", -1)),
                        _createElementVNode("div", _hoisted_42, [
                          (original(originId)?.imageUrl)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: original(originId)?.imageUrl || '',
                                alt: "",
                                class: "h-24 w-20 shrink-0 rounded bg-white object-contain",
                                referrerpolicy: "no-referrer"
                              }, null, 8, _hoisted_43))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("p", _hoisted_45, _toDisplayString(original(originId)?.reference || originId), 1),
                            _createElementVNode("p", null, _toDisplayString(original(originId)?.color), 1),
                            _createElementVNode("p", null, _toDisplayString(originalSizes(originId)), 1),
                            _createElementVNode("p", null, [
                              (original(originId)?.vendu_par !== 'tailles' && original(originId)?.quantite_pack)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString(original(originId)?.quantite_pack) + " paquet(s) · ", 1)
                                  ], 64))
                                : _createCommentVNode("", true),
                              _createTextVNode(_toDisplayString(originalQuantity(originId)) + " pièce(s)", 1)
                            ]),
                            (quotedLine(originId))
                              ? (_openBlock(), _createElementBlock("p", _hoisted_46, _toDisplayString(_unref(replacementMoney)(quotedLine(originId)?.origine.montant_ht ?? 0)) + " HT · " + _toDisplayString(_unref(replacementMoney)(quotedLine(originId)?.origine.montant_ttc ?? 0)) + " TTC", 1))
                              : (_openBlock(), _createElementBlock("p", _hoisted_47, _toDisplayString(originalAmount(originId) || 'Montant d’origine non renseigné.'), 1))
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("p", _hoisted_49, [
                          _cache[10] || (_cache[10] = _createTextVNode("Remplacements proposés")),
                          (selectedFor(originId).length > 1)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(" · 1 au choix")
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedFor(originId), (selection) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: selection.id_produit_remplacement,
                            class: "space-y-3 border-b border-green-100 pb-4 last:border-0 last:pb-0"
                          }, [
                            _createElementVNode("div", _hoisted_50, [
                              (product(selection)?.image_url)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: product(selection)?.image_url,
                                    alt: "",
                                    class: "h-24 w-20 shrink-0 rounded bg-white object-contain",
                                    referrerpolicy: "no-referrer"
                                  }, null, 8, _hoisted_51))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_52, [
                                _createElementVNode("p", _hoisted_53, _toDisplayString(product(selection)?.reference), 1),
                                _createElementVNode("p", null, _toDisplayString(product(selection)?.couleur), 1)
                              ]),
                              _createElementVNode("button", {
                                type: "button",
                                disabled: busy.value,
                                class: "shrink-0 text-red-700 underline disabled:opacity-50",
                                onClick: ($event: any) => (removeProduct(selection))
                              }, "Retirer", 8, _hoisted_54)
                            ]),
                            (product(selection)?.vendu_par !== 'tailles')
                              ? (_openBlock(), _createElementBlock("label", _hoisted_55, [
                                  _cache[11] || (_cache[11] = _createTextVNode("Quantité de paquets ")),
                                  _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": ($event: any) => ((selection.quantite_pack) = $event),
                                    disabled: busy.value,
                                    type: "number",
                                    min: "1",
                                    max: "10000",
                                    class: "mt-1 block w-28 rounded border p-2",
                                    onInput: ($event: any) => (updatePacks(selection))
                                  }, null, 40, _hoisted_56), [
                                    [
                                      _vModelText,
                                      selection.quantite_pack,
                                      void 0,
                                      { number: true }
                                    ]
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            (product(selection)?.vendu_par !== 'tailles')
                              ? (_openBlock(), _createElementBlock("p", _hoisted_57, "0 = taille non souhaitée. Modifier les paquets réinitialise les quantités."))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_58, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sizeInputs(selection), (size) => {
                                return (_openBlock(), _createElementBlock("label", {
                                  key: size.index
                                }, [
                                  _createTextVNode(_toDisplayString(size.label) + " ", 1),
                                  _createElementVNode("input", {
                                    value: selection.quantites[size.index],
                                    disabled: busy.value,
                                    type: "number",
                                    min: "0",
                                    max: product(selection)?.vendu_par === 'tailles' ? 10000 : Math.min(10000, (product(selection)?.pack[size.index] || 0) * selection.quantite_pack),
                                    class: "mt-1 block w-20 rounded border p-2",
                                    onInput: ($event: any) => (updateSizeQuantity(selection, size.index, $event))
                                  }, null, 40, _hoisted_59)
                                ]))
                              }), 128))
                            ]),
                            _createElementVNode("p", null, _toDisplayString(selection.quantites.reduce((sum, q) => sum + (Number(q) || 0), 0)) + " pièce(s)", 1),
                            (quotedProduct(selection))
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                  _createElementVNode("p", null, _toDisplayString(_unref(replacementMoney)(quotedProduct(selection)?.montant_ht ?? 0)) + " HT · " + _toDisplayString(_unref(replacementMoney)(quotedProduct(selection)?.montant_ttc ?? 0)) + " TTC", 1),
                                  (quotedProduct(selection)?.charge_vendeur_ttc)
                                    ? (_openBlock(), _createElementBlock("p", _hoisted_60, "Charge vendeur si choisi : " + _toDisplayString(_unref(replacementMoney)(quotedProduct(selection)?.charge_vendeur_ttc ?? 0)) + " TTC", 1))
                                    : (quotedProduct(selection)?.a_rembourser_ttc)
                                      ? (_openBlock(), _createElementBlock("p", _hoisted_61, "Remboursement estimé : " + _toDisplayString(_unref(replacementMoney)(quotedProduct(selection)?.a_rembourser_ttc ?? 0)) + " TTC (hors remise fixe)", 1))
                                      : _createCommentVNode("", true)
                                ], 64))
                              : (!selectionReady(selection))
                                ? (_openBlock(), _createElementBlock("ul", _hoisted_62, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quantityErrors(selection), (message) => {
                                      return (_openBlock(), _createElementBlock("li", { key: message }, _toDisplayString(message), 1))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("p", _hoisted_63, _toDisplayString(quoting.value ? 'Calcul du devis…' : 'Devis indisponible.'), 1))
                          ]))
                        }), 128)),
                        (!selectedFor(originId).length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[12] || (_cache[12] = _createElementVNode("p", null, "Aucun candidat proposé.", -1)),
                              _createElementVNode("button", {
                                type: "button",
                                disabled: busy.value,
                                class: "font-medium text-indigo-700 underline",
                                onClick: ($event: any) => (focusOrigin(originId))
                              }, "Choisir un produit", 8, _hoisted_64)
                            ], 64))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ], 8, _hoisted_38))
              }), 128))
            ])),
        (step.value === 2 && preview.value && fixedDiscount.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_65, "Remise prise en compte : " + _toDisplayString(_unref(replacementMoney)(fixedDiscount.value)) + " HT", 1))
          : _createCommentVNode("", true)
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_66, [
          (quoting.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_67, "Calcul en cours…"))
            : _createCommentVNode("", true),
          (stepIncompleteOrigins.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                _createElementVNode("p", null, _toDisplayString(step.value === 1 ? 'Choisissez un produit pour :' : 'Vérifiez les quantités pour :'), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stepIncompleteOrigins.value, (id) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: id,
                    type: "button",
                    disabled: busy.value,
                    class: "mr-3 font-medium underline",
                    onClick: ($event: any) => (focusOrigin(id))
                  }, _toDisplayString(original(id)?.reference || id), 9, _hoisted_69))
                }), 128))
              ]))
            : (!selections.value.length)
              ? (_openBlock(), _createElementBlock("p", _hoisted_70, "Cochez au moins un article à remplacer."))
              : _createCommentVNode("", true),
          (modalError.value || quoteError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_71, [
                _createTextVNode(_toDisplayString(quoteError.value || modalError.value) + " ", 1),
                (quoteError.value && !quoting.value)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "underline",
                      onClick: refreshQuote
                    }, "Réessayer"))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (step.value === 2 && sellerCharge.value > 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_72, "À votre charge (max.) : " + _toDisplayString(_unref(replacementMoney)(sellerCharge.value)) + " TTC. Aucun supplément client.", 1))
            : _createCommentVNode("", true),
          (step.value === 2)
            ? (_openBlock(), _createElementBlock("label", _hoisted_73, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((confirmed).value = $event)),
                  disabled: busy.value,
                  type: "checkbox",
                  class: "mt-0.5 h-4 w-4 shrink-0"
                }, null, 8, _hoisted_74), [
                  [_vModelCheckbox, confirmed.value]
                ]),
                _cache[13] || (_cache[13] = _createElementVNode("span", null, "Je confirme la disponibilité et les écarts de prix à ma charge.", -1))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_75, [
            _createElementVNode("button", {
              type: "button",
              disabled: busy.value,
              class: "border rounded px-3 py-2",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (visible.value = false))
            }, "Fermer", 8, _hoisted_76),
            (step.value === 2)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  disabled: busy.value,
                  class: "border rounded px-3 py-2",
                  onClick: previousStep
                }, "Retour", 8, _hoisted_77))
              : _createCommentVNode("", true),
            (step.value === 1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  type: "button",
                  disabled: !_ctx.canPropose || busy.value || searching.value || !candidatesChosen.value,
                  class: "bg-indigo-600 text-white rounded px-3 py-2 disabled:opacity-50",
                  onClick: nextStep
                }, "Suivant", 8, _hoisted_78))
              : (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  type: "button",
                  disabled: !_ctx.canPropose || busy.value || quoting.value || !confirmed.value || !quoteReady.value,
                  class: "bg-indigo-600 text-white rounded px-3 py-2 disabled:opacity-50",
                  onClick: submit
                }, _toDisplayString(busy.value ? 'Traitement…' : 'Proposer'), 9, _hoisted_79))
          ])
        ])
      ]),
      _: 1
    }, 8, ["isVisible"])
  ]))
}
}

})